import { RouteConfig } from 'vue-router';

export const epuapSignSuccessRoute: RouteConfig = {
  path: 'sign_success',
  name: 'epuapSignSuccess',
  component: () => import(/* webpackChunkName: "SignResult" */ '@/views/mainRoute/document/epuap/SignResult.vue'),
  meta: { breadcrumb: { title: 'Stan podpisu' } },
  props: {
    success: true
  }
};
